export const ACTION_TYPE = "categoryType";

export const DEFAULT_CATEGORY_IMAGE =
    "/portal/static-assets/images/digital-menu/all-theme-assets/placeholder.png";

export const PADDING_LEFT = 20;
export const IMAGE_DIMENSION = 60;
